<div class="document-viewer-backdrop"
     *ngIf="isOpen"
     (click)="onBackdropClick($event)">

  <div class="document-viewer-modal" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="viewer-header">
      <div class="header-left">
        <ng-icon name="tablerFileDescription" class="document-icon"></ng-icon>
        <h3 class="document-title">{{ config?.fileName || 'Document' }}</h3>
      </div>

      <div class="header-actions">
        <button
          *ngIf="config?.allowDownload !== false"
          class="header-btn"
          (click)="download()"
          title="Download">
          <ng-icon name="tablerDownload"></ng-icon>
        </button>

        <button
          class="header-btn close-btn"
          (click)="close()"
          title="Close">
          <ng-icon name="tablerX"></ng-icon>
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div class="viewer-body" *ngIf="status === DocumentStatus.LOADING">
      <div class="loading-container">
        <div class="spinner"></div>
        <p>Loading document...</p>
      </div>
    </div>

    <!-- Error State -->
    <div class="viewer-body" *ngIf="status === DocumentStatus.ERROR">
      <div class="error-container">
        <ng-icon name="tablerAlertTriangle" class="error-icon"></ng-icon>
        <p class="error-message">{{ errorMessage }}</p>
        <button class="btn btn-primary" (click)="close()">Close</button>
      </div>
    </div>

    <!-- PDF Viewer -->
    <div class="viewer-body"
         *ngIf="config?.fileType === 'pdf' && status === DocumentStatus.READY">
      <ngx-extended-pdf-viewer
        [src]="pdfSrc"
        [height]="'calc(100vh - 120px)'"
        [useBrowserLocale]="true"
        [showToolbar]="true"
        [showSidebarButton]="false"
        [showFindButton]="true"
        [showPrintButton]="false"
        [showDownloadButton]="false"
        [showZoomButtons]="true"
        [showPagingButtons]="true"
        [showRotateButton]="false"
        [showHandToolButton]="false"
        [showScrollingButton]="false"
        [showSpreadButton]="false"
        [showPropertiesButton]="false"
        [showOpenFileButton]="false"
        [showSecondaryToolbarButton]="false"
        [textLayer]="true">
      </ngx-extended-pdf-viewer>
    </div>

    <!-- DOCX Viewer -->
    <div class="viewer-body docx-viewer-body"
         *ngIf="config?.fileType === 'docx' &&
                (status === DocumentStatus.RENDERING || status === DocumentStatus.READY)">
      <div #docxContainer class="docx-container"></div>
    </div>

    <!-- TXT Viewer -->
    <div class="viewer-body txt-viewer-body"
         *ngIf="config?.fileType === 'txt' &&
                (status === DocumentStatus.RENDERING || status === DocumentStatus.READY)">
      <pre #txtContainer class="txt-container"></pre>
    </div>

    <!-- Image Viewer -->
    <div class="viewer-body image-viewer-body"
         *ngIf="config?.fileType === 'image' && status === DocumentStatus.READY">
      <div class="image-container">
        <img [src]="imageSrc" [alt]="config?.fileName || 'Image'" class="image-preview" />
      </div>
    </div>

    <!-- Unsupported Format Fallback (for .doc and Excel files) -->
    <div class="viewer-body unsupported-format-body"
         *ngIf="showUnsupportedFormat && status === DocumentStatus.READY">
      <div class="unsupported-container">
        <ng-icon class="unsupported-icon"
           [name]="config?.fileType === 'excel' ? 'tablerFileSpreadsheet' : 'tablerFileDescription'"
           [style.color]="config?.fileType === 'excel' ? '#1d6f42' : '#2b579a'"></ng-icon>
        <h4 class="unsupported-title">Preview Not Available</h4>
        <p class="unsupported-message">
          <ng-container *ngIf="config?.fileType === 'excel'">
            Excel files cannot be previewed in the browser.
            Please download the file to view it in Microsoft Excel or another compatible application.
          </ng-container>
          <ng-container *ngIf="config?.fileType === 'doc'">
            The old .doc format cannot be previewed in the browser.
            Please download the file to view it in Microsoft Word or another compatible application.
          </ng-container>
        </p>
        <button class="btn btn-primary download-btn" (click)="download()">
          <ng-icon name="tablerDownload"></ng-icon> Download File
        </button>
      </div>
    </div>

  </div>
</div>
